import { render } from "./Unit1-2.vue?vue&type=template&id=1669b90b&scoped=true"
import script from "./Unit1-2.vue?vue&type=script&lang=js"
export * from "./Unit1-2.vue?vue&type=script&lang=js"

import "../assets/css/common.css?vue&type=style&index=0&lang=css"
import "../assets/css/Unit1-2.css?vue&type=style&index=1&id=1669b90b&scoped=true&lang=css"
import "./Unit1-2.vue?vue&type=style&index=2&id=1669b90b&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\project\\national-museum-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1669b90b"]])

export default __exports__